import { ReactNode, useCallback, useState } from 'react';

import Navbar from '../Navbar';
import Sidenav from '../Sidenav';

import {
  containerClassName,
  innerClassName,
  layoutClassName,
  wrapperClassName,
} from './styles';

interface Props {
  children: ReactNode;
}

const Layout = ({ children }: Props) => {
  const [isMenuVisible, setMenuVisibility] = useState<boolean>(false);

  const onToggleMenu = useCallback(() => {
    setMenuVisibility(!isMenuVisible);
  }, [isMenuVisible]);

  const hideMenu = useCallback(() => {
    setMenuVisibility(false);
  }, []);

  return (
    <>
      <Navbar isMenuVisible={isMenuVisible} onToggleMenu={onToggleMenu} />
      <Sidenav isMenuVisible={isMenuVisible} hideMenu={hideMenu} />
      <main className={layoutClassName}>
        <div className={wrapperClassName}>
          <div className={containerClassName}>
            <div className={innerClassName}>{children}</div>
          </div>
        </div>
      </main>
    </>
  );
};

Layout.displayName = 'Layout';

export default Layout;
